"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFilterFieldExists = exports.isFilterField = exports.isFilterGroup = exports.getFilterParamsFieldSlugs = exports.filterParamsFilterFieldIter = exports.cleanFilterParams = exports.mapFilterParams = exports.filterUniqueValues = exports.filterNotNullValues = void 0;
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const primitives_1 = require("../safe-field-value/type-checking/primitives");
/**
 * Filters out null values from the given array and returns a new array
 * containing only non-null values.
 *
 * @template Value - The type of values in the array.
 * @param {Array<Value | null>} array - The array to filter.
 * @returns {Value[]} - The new array with non-null values.
 */
const filterNotNullValues = (array) => {
    const result = [];
    for (const num of array) {
        if (!(0, primitives_1.isNullValue)(num)) {
            result.push(num);
        }
    }
    return result;
};
exports.filterNotNullValues = filterNotNullValues;
function filterUniqueValues(currentValue, index, array) {
    return array.findIndex((value) => (0, react_fast_compare_1.default)(currentValue, value)) === index;
}
exports.filterUniqueValues = filterUniqueValues;
/**
 * Iterates over filter conditions and apply modifier for each field condition.
 */
function mapFilterParams(filterParams, modifier) {
    function mapConditions(conditions) {
        const updatedConditions = [];
        conditions.forEach((condition) => {
            if (isFilterGroup(condition)) {
                const groupConditions = mapConditions(condition.conditions);
                if (groupConditions.length) {
                    updatedConditions.push({
                        is_group: true,
                        operator: condition.operator,
                        conditions: groupConditions,
                    });
                }
                return;
            }
            if (isFilterField(condition)) {
                updatedConditions.push(modifier(condition));
            }
        });
        return updatedConditions;
    }
    return {
        operator: filterParams.operator || "or",
        conditions: mapConditions(filterParams.conditions || []),
    };
}
exports.mapFilterParams = mapFilterParams;
/**
 * Checks every field's condition by predicate function and removes not matched conditions.
 */
function cleanFilterParams(filterParams, predicate) {
    function filterConditions(conditions) {
        const filteredConditions = [];
        conditions.forEach((condition) => {
            if (isFilterGroup(condition)) {
                const groupConditions = filterConditions(condition.conditions);
                if (groupConditions.length) {
                    filteredConditions.push({
                        is_group: true,
                        operator: condition.operator,
                        conditions: groupConditions,
                    });
                }
                return;
            }
            if (isFilterField(condition) && predicate(condition)) {
                filteredConditions.push(condition);
            }
        });
        return filteredConditions;
    }
    return {
        operator: filterParams.operator || "or",
        conditions: filterConditions(filterParams.conditions || []),
    };
}
exports.cleanFilterParams = cleanFilterParams;
/**
 * Recursively iterates over filter params conditions and yields fields conditions.
 */
function* filterParamsFilterFieldIter(filterParams) {
    yield* conditionsIter(filterParams.conditions || []);
}
exports.filterParamsFilterFieldIter = filterParamsFilterFieldIter;
function* conditionsIter(conditions) {
    for (const condition of conditions) {
        if (isFilterGroup(condition)) {
            yield* conditionsIter(condition.conditions);
        }
        else if (isFilterField(condition)) {
            yield condition;
        }
    }
}
/**
 * Iterates over filter params conditions and returns all field slugs.
 */
function getFilterParamsFieldSlugs(filterParams) {
    const allSlugs = new Set();
    for (const filterField of filterParamsFilterFieldIter(filterParams)) {
        allSlugs.add(filterField.field);
    }
    return Array.from(allSlugs);
}
exports.getFilterParamsFieldSlugs = getFilterParamsFieldSlugs;
function isFilterGroup(condition) {
    return "is_group" in condition && condition.is_group;
}
exports.isFilterGroup = isFilterGroup;
function isFilterField(condition) {
    return "field" in condition && "comparison" in condition;
}
exports.isFilterField = isFilterField;
const isFilterFieldExists = (filters, field, comparison) => {
    return filters.conditions.some((condition) => {
        if (isFilterGroup(condition)) {
            return (0, exports.isFilterFieldExists)(condition, field, comparison);
        }
        if (isFilterField(condition)) {
            return condition.field === field && condition.comparison === comparison;
        }
        return false;
    });
};
exports.isFilterFieldExists = isFilterFieldExists;
